import { Component, OnInit } from '@angular/core';
import { InfoReportGuard } from 'src/app/info-reports/info-report.guard';
import { InfoReportService } from 'src/app/services/info-report.service';
import { environment } from 'src/environments/environment';
import { AppPermissions } from 'src/app/shared/app.permissions';
import { AuthorizationModel } from 'src/app/shared/models/authorization-model';

@Component({
  selector: 'ness-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent {

  readonly canViewPBIReports: AuthorizationModel = AppPermissions.canViewPBIReports;
  public reportUrl: string = `${environment.pbiReportDashboard}`;
  constructor(
    private infoReportGuard: InfoReportGuard,
    private infoReportService: InfoReportService
  ) { }

}
